import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import AdminDash from "./AdminDash";
import AdminOrgs from "./AdminOrgs";
import AdminOrgDetail from "./AdminOrgDetail";
import AdminProperties from "./AdminProperties";
import AdminTenants from "./AdminTenants";
import AdminServicePersons from "./AdminServicePersons";
import AdminPricing from "./AdminPricing";
import AdminPerPropertyPlan from "./AdminPerPropertyPlan";
import AdminReports from "./AdminReports";
import AdminFeedback from "./AdminFeedback";
import AdminCampaign from "./AdminCampaign";
import AdminVacateQueue from "./AdminVacateQueue";
import AdminVacateDetail from "./AdminVacateDetail";

export default function AdminPage() {
  const { page } = useContext(Ctx);
  switch (page) {
    case "adminOrgs": return <AdminOrgs />;
    case "adminOrgDetail": return <AdminOrgDetail />;
    case "adminProperties": return <AdminProperties />;
    case "adminTenants": return <AdminTenants />;
    case "adminServicePersons": return <AdminServicePersons />;
    case "adminPricing": return <AdminPricing />;
    case "adminPerPropertyPlan": return <AdminPerPropertyPlan />;
    case "adminReports": return <AdminReports />;
    case "adminFeedback": return <AdminFeedback />;
    case "adminCampaign": return <AdminCampaign />;
    case "adminVacateQueue": return <AdminVacateQueue />;
    case "adminVacateDetail": return <AdminVacateDetail />;
    default: return <AdminDash />;
  }
}
